import React from 'react';
import { Box, Typography } from '@mui/material';

// Cabeçalho de cada etapa do envio: título, explicação curta e ação opcional à direita
export function StepSection({ title, description, action, children }: { title: string; description?: string; action?: React.ReactNode; children: React.ReactNode }) {
    return (
        <Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 2, mb: 2.5, flexWrap: 'wrap' }}>
                <Box>
                    <Typography variant="h6" fontWeight={700}>{title}</Typography>
                    {description && <Typography variant="body2" color="text.secondary">{description}</Typography>}
                </Box>
                {action}
            </Box>
            {children}
        </Box>
    );
}
